<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

        <template v-slot:card-header>
          <router-link :to="{ name: `${walletRoutePrefix}.index` }"  class="btn btn-primary btn-sm">
            <i class="fa fa-arrow-left"></i>
          </router-link>
        </template>

        <template v-slot:card-header-search>
          <search v-model="lastPage" :listHandler="getList"/>
        </template>

        <template v-slot:table-rows>
          <tr v-for="item in items" :key="item.id">
            <td> {{ item.captainId   }} </td>
            <td> {{ item.walletId }} </td>
            <td> {{ item.transactionTypeTitle }} </td>
            <td> {{ item.balance }} </td>
            <td> {{ item.transactionType }} </td>
            <td> {{ item.amount }} </td>
            <td> {{ item.note }} </td>
            <td class="text-direction-ltr"> {{ item.createdAt | moment("Y-MM-DD hh:mm:ss A")  }} </td>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>

        <template v-slot:card-footer>
          <export-action :crudCode="exportCode" v-can:report="permissionPrefix"></export-action>
        </template>
      </card-container>
    </div>
  </div>
</template>
<script>

  import {mapGetters} from "vuex";
  import { WALLET_TRANSACTIONS_LIST as CRUD_ACTION_LIST} from 'actions/wallet_transactions';
  import search from "./partials/search";
  const WALLET_CODE=`wallets`;
  const CRUD_CODE=`wallet_transactions`;
  const CRUD_PERMISSION_CODE=`wallets`;
  export default {
    name: "WalletTransactionIndex",
    components:{
      search,
    },
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        walletRoutePrefix: WALLET_CODE,
        walletTransPrefix: WALLET_CODE,
        exportCode:`wallet/transactions`,
        tableHeaders:[
          {
            'title':`fields.captain_id`
          },
          {
            'title':`fields.wallet_id`
          },
          {
            'title':`fields.title`
          },
          {
            'title':`fields.balance`
          },
          {
            'title':`fields.type`
          },
          {
            'title':`fields.amount`
          },
          {
            'title':`fields.note`
          },
          {
            'title':`fields.created_at`
          }
        ],
        items: [],
        perPage:20,
        totalElements:0,
        lastPage:0,
        serverError: '',
        fieldErrors: {},
        loading: false,
      }
    },
    mounted() {
      this.getList();
    },
    computed:{
      ...mapGetters([
        "getSearchFilters","getSearchFiltersIfExists","getSearchFiltersSensitized"
      ])
    },
    methods: {
      getList(){
        this.$store.dispatch(CRUD_ACTION_LIST,{
          data:{
            pageId: this.getCurrentPage()-1,
            ...this.getSearchFiltersSensitized
          },
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        });
      },
      pagination(page){
        if(page!== this.getCurrentPage()){
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page,
              ...this.getSearchFiltersIfExists
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage>=1?currentPage:1);
      },
    }
  };
</script>
